<template>
	<div>
		<x-header :path="$path"
				  :backColor="backColor"
				  :textColor="textColor"
				  :activeTopIndex="activeIndex.top"
				  @go="activeTo"></x-header>
		<div class="banner-area">
			<div class="banner-con" style="height: 482px">
				<img :src="source.banner" alt="Xhorse"/>
			</div>
		</div>
		<div class="belong-area">
			<div class="belong-con">
				<div class="top-bar" :style="topBar">
					<div class="bread-con">
						<div class="txt">
							Home/	{{ getTopBarTitle }}
						</div>
					</div>
				</div>
				<div class="item-con">
					<div class="x-flow side" :class="[activeClass]">
						<x-side :activeSideIndex="activeIndex.side"
								:activeTopIndex="activeIndex.top"
								@go="activeTo"
						></x-side>
					</div>
					<div class="x-flow body" :class="[activeClass]">
						<x-main :activeSideIndex="activeIndex.side"
								:activeTopIndex="activeIndex.top"
								@go="activeTo"
						></x-main>
					</div>
				</div>
			</div>
		</div>
		<x-footer></x-footer>
	</div>
</template>

<script>
    import xHeader from '@/components/zh-cn/header.vue'
    import xSide from '@/components/zh-cn/side.vue'
    import xMain from '@/components/zh-cn/main.vue'

    import banner_new1 from '@/assets/resource/images/support/banner_support_01.png'
    import banner_new2 from '@/assets/resource/images/support/banner_support_01.png'
    import banner_new3 from '@/assets/resource/images/support/banner_support_01.png'
    export default {
        components: {
            xHeader: xHeader,
            xSide: xSide,
            xMain: xMain,
            xFooter: () => import('@/components/zh-cn/footer')
        },
        data: function () {
            return {
                textColor: '#2A2E2E',
                backColor: '#FFFFFF',
                topBar: {
                    height: '55px'
                },
                source: {
                    banner: banner_new1,
                },
                activeIndex: {
                    top: [],
                    side: []
                },
                activeClass: '',
                backStyle: {
                    bottom: '48px'
                }
            };
        },
        methods: {
            activeTo(params){
                console.log("Template[support]: ", params)
                const _this = this;
                const componentInfo = _this.$RegistedName;
                const dateTime = (new Date()).getTime()
                if (params.type == 'top') {
                    var fullPath = params.val.map((item) => {
                        if (toString(item).indexOf('-')) {
                            return parseInt(item.toString().split('-').reverse()[0]);
                        } else {
                            return parseInt(item);
                        }
                    });
                    _this.activeIndex.top = fullPath;
                    _this.activeIndex.side = fullPath.slice(-1);
                    _this.$router.push({name: componentInfo[fullPath[0]].componentName, params: {date: dateTime}})
                } else {
                    _this.activeIndex.side = params.val
                }
            },
            getMainPageHeight(activeInfo) {
                const _this = this;
                var activeTop = activeInfo.top;
                var activeSide = activeInfo.side;
                var assem = [activeTop[0], activeTop[1], activeSide[0]];
                switch (assem.join(',')) {
                    case "5,1,1":
                        _this.activeClass = 'support-cutting-class';
                        break;
                    case "5,2,1":
                        _this.activeClass = 'support-video-class';
                        break;
                    default:
                        _this.activeClass = 'support-cutting-class';
                        break;
                }
            }
        },
        computed: {
            getTopBarTitle: function () {
                const _this = this;
                const activeTop = _this.activeIndex.top;
                var activeTitle = '';
                switch (parseInt(activeTop[1])) {
                    case 1:
                        activeTitle = 'Tech Support';
                        break;
                    case 2:
                        activeTitle = 'Tutorial Videos';
                        break;
                }
                return activeTitle;
            }
        },
        watch: {
            'activeIndex.top': function (val) {
                const _this = this;
                switch (parseInt(val[1])) {
                    case 1:
                        _this.source.banner = banner_new1;
                        break;
                    case 2:
                        _this.source.banner = banner_new2;
                        break;
                    case 3:
                        _this.source.banner = banner_new3;
                        break;
                }
            },
            activeIndex: {
                handler(activeInfo){
                    const _this = this;
                    _this.getMainPageHeight(activeInfo);
                    console.log("监听：", activeInfo)
                },
                deep: true
            }
        },
        mounted(){
            const _this = this;
            const activePath = _this.$store.state;
            _this.activeIndex.top = activePath.activeTop;
            _this.activeIndex.side = activePath.activeSide;
            $("#x-header .h-li").css({color: '#2A2E2E'})
        },
        beforeRouteLeave (to, from, next) {
                 if(['/software','/xhorseIM','/download'].includes(to.path)){
                next(true)
                return
             }
            const _this = this;
            var data = {
                side: _this.activeIndex.side,
                top: _this.activeIndex.top,
            };

            if (to.params.hasOwnProperty('activeTop') && to.params.hasOwnProperty('activeSide')) {
                data.side = to.params.activeSide;
                data.top = to.params.activeTop;
            }

            _this.$store.commit('setActivePath', {
                type: 'all',
                val: data
            });
            next(true)
        }
    }

</script>

<style scoped>

	@import "../../assets/css/support.css";

</style>



// WEBPACK FOOTER //
// src/components/zh-cn/support.vue